export interface ICourse {
  type: string;
  slug: string;
  lessons: number;
  title: string;
  description: string;
}

export const courses = {
  'Social-Media-Best-Practices': {
    type: 'embed',
    slug: 'Social-Media-Best-Practices',
    lessons: 6,
    title: 'Social Media Best Practices',
    description:
      'This course offers concise tips for optimizing content and accounts, addressing frequently asked questions.',
  },
  'Social-Media-Release-Promo': {
    type: 'embed',
    slug: 'Social-Media-Release-Promo',
    lessons: 3,
    title: 'Promote Your Release',
    description:
      'This short course teaches how to promote releases on social media, providing tips for effective content rollout.',
  },
  'spotify-discovery-mode': {
    type: 'embed',
    slug: 'spotify-discovery-mode',
    lessons: 2,
    title: 'Spotify Discovery Mode',
    description: "This short course introduces you to Spotify's Discovery Mode feature.",
  },
  'tiktok-seo-starter-pack': {
    type: 'embed',
    slug: 'tiktok-seo-starter-pack',
    lessons: 5,
    title: 'TikTok SEO Starter Pack',
    description:
      'This short course introduces you to the basics of TikTok SEO with our Starter Pack.',
  },
  'social-media-introduction': {
    type: 'embed',
    slug: 'social-media-introduction',
    lessons: 8,
    title: 'Social Media Course: Introduction',
    description: 'This introductory course provides an overview of social media essentials.',
  },
  'social-media-intermediate': {
    type: 'embed',
    slug: 'social-media-intermediate',
    lessons: 6,
    title: 'Social Media Course: Intermediate',
    description:
      'Enhance your social media skills with this intermediate course on strategies and audience growth.',
  },
  'branding-exercise': {
    type: 'embed',
    slug: 'branding-exercise',
    lessons: 1,
    title: 'Branding Exercise',
    description:
      'This exercise presents different questions to help you understand the core of your brand.',
  },
  'mastering-brand-identity': {
    type: 'embed',
    slug: 'mastering-brand-identity',
    lessons: 3,
    title: 'Mastering Brand Identity',
    description:
      'This course guides you to deep dive into your brand persona, and develop a coherent brand identity.',
  },
  'live-touring': {
    type: 'embed',
    slug: 'live-touring',
    lessons: 7,
    title: 'Live Touring',
    description:
      'This course teaches artists and their teams how to approach live performance strategically, from routing and budgeting a tour to deal types, booking, and promotion.',
  },
  // 'Social-Media-Release-Promo': {
  //   type: 'pdf',
  //   slug: 'Social-Media-Release-Promo',
  //   lessons: 2,
  //   title: 'Promote Your Release',
  //   description:
  //     'This short course teaches how to promote releases on social media, providing tips for effective content rollout.',
  // },
};
